import { Stack, Theme, useMediaQuery } from "@mui/material"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"

/**
 * Loading skeleton single gen / demand device summary pages
 */
const SingleDeviceSkeleton = (): ReactElement => {
    const matches = useMediaQuery((theme: Theme) =>
        theme.breakpoints.down("md")
    )
    return (
        <Stack spacing={GRID_SPACING} justifyContent="flex-start" height="100%">
            <AppSkeleton height="140px" variant="rectangular" />
            <Stack
                spacing={GRID_SPACING}
                direction={{ xs: "column", md: "row" }}
                height="100%"
            >
                <Stack
                    spacing={GRID_SPACING}
                    width={{ xs: "100%", md: "50%" }}
                    height="100%"
                >
                    <AppSkeleton height="30%" variant="rectangular" />
                    <AppSkeleton height="100%" variant="rectangular" />
                </Stack>
                <AppSkeleton
                    width={matches ? "100%" : "50%"}
                    height="100%"
                    variant="rectangular"
                />
            </Stack>
        </Stack>
    )
}
export default SingleDeviceSkeleton
